import { z } from 'zod';
import { moneyOutSchema, optionalMoney, optionalText, requiredText, versionField } from './fields';
import { idSchema } from './ids';

/** Customer products (FR-CUST-011/012) — their own records, not part of the customer row. */
export const productInputSchema = z.object({
  name: requiredText(200, 'Nosaukums ir obligāts!'),
  value: optionalMoney,
  comment: optionalText(2000),
});
export type ProductInput = z.input<typeof productInputSchema>;

export const productUpdateSchema = productInputSchema.extend(versionField);

export const productSchema = z.object({
  id: idSchema,
  customerId: idSchema,
  name: z.string(),
  value: moneyOutSchema,
  comment: z.string().nullable(),
  version: z.number().int(),
  createdAt: z.string(),
  updatedAt: z.string(),
});
export type Product = z.infer<typeof productSchema>;
